import { useState } from "react";
import { TIMEREX_URL } from "../config";

const PROS = [
  {
    id: 1, type: "行政書士", icon: "📋",
    desc: "補助金申請書類の作成・提出代行",
    price: "5〜50万円（固定報酬）",
    cases: ["補助金申請代行", "事業計画書作成", "農地転用申請"],
  },
  {
    id: 2, type: "税理士", icon: "📊",
    desc: "確定申告・青色申告・節税アドバイス",
    price: "月額2〜5万円〜",
    cases: ["青色申告サポート", "税務相談", "記帳代行"],
  },
  {
    id: 3, type: "農業経営コンサル", icon: "🌾",
    desc: "経営改善・補助金戦略の総合サポート",
    price: "相談による",
    cases: ["経営計画策定", "補助金戦略", "6次産業化支援"],
  },
];

export default function ProScreen({ onGoSubsidy }) {
  const [selected, setSelected] = useState(null);
  const [sent,     setSent]     = useState(false);
  const [form,     setForm]     = useState({ name: "", phone: "", detail: "" });

  if (sent) return (
    <div className="screen" style={{ textAlign: "center" }}>
      <div style={{ fontSize: "4rem", margin: "2rem 0" }}>✅</div>
      <h2 className="screen-title">相談依頼を送りました</h2>
      <p className="sub" style={{ margin: "1rem 0 2rem" }}>1〜2営業日以内にご連絡いたします。</p>
      <button className="primary-btn" onClick={() => { setSent(false); setSelected(null); setForm({ name: "", phone: "", detail: "" }); }}>
        トップに戻る
      </button>
    </div>
  );

  // 行政書士は、予約ページで日時を選んで直接相談できる
  if (selected && selected.type === "行政書士" && TIMEREX_URL) return (
    <div className="screen">
      <button className="back-btn" onClick={() => setSelected(null)}>← 戻る</button>
      <div style={{ fontSize: "3rem", textAlign: "center", margin: "1rem 0" }}>{selected.icon}</div>
      <h2 className="screen-title">{selected.type}に相談する</h2>
      <p className="sub" style={{ marginBottom: "1rem" }}>
        補助金にくわしい提携の行政書士に、オンラインで相談できます。制度を決めていなくても大丈夫です。やりたいことを聞いて、国・県・市町村の制度から合うものを一緒に探します。
      </p>
      <a href={TIMEREX_URL} target="_blank" rel="noreferrer" className="primary-btn"
         style={{ display: "block", textAlign: "center", textDecoration: "none" }}>
        📅 相談の日時を選ぶ
      </a>
      <div className="notice">
        💡 先に「相談シート」を作っておくと、1回の相談で話が進みます。タップで答えるだけ、1分ほどです。
      </div>
      <button className="primary-btn" style={{ background: "#fff", color: "#2e7d32", border: "2px solid #2e7d32", marginTop: 0 }} onClick={onGoSubsidy}>
        📋 相談シートを作ってから予約する
      </button>
    </div>
  );

  if (selected) return (
    <div className="screen">
      <button className="back-btn" onClick={() => setSelected(null)}>← 戻る</button>
      <div style={{ fontSize: "3rem", textAlign: "center", margin: "1rem 0" }}>{selected.icon}</div>
      <h2 className="screen-title">{selected.type}に相談する</h2>
      <p className="sub" style={{ marginBottom: "1rem" }}>{selected.desc}</p>
      <div className="notice">💡 相談は無料です。費用の見積もりをご確認後にご依頼いただけます。</div>

      <label className="field-label">お名前</label>
      <input className="field-input" placeholder="田中 太郎" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
      <label className="field-label">電話番号</label>
      <input className="field-input" placeholder="090-0000-0000" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
      <label className="field-label">相談内容</label>
      <textarea className="field-input" style={{ height: 100, resize: "vertical" }}
        placeholder="例：補助金の申請書類を作成してほしい"
        value={form.detail} onChange={(e) => setForm({ ...form, detail: e.target.value })} />

      <button className="primary-btn" disabled={!form.name || !form.phone || !form.detail} onClick={() => setSent(true)}>
        相談依頼を送る（無料）
      </button>
    </div>
  );

  return (
    <div className="screen">
      <h2 className="screen-title">👨‍💼 士業に頼む</h2>
      <p className="sub" style={{ marginBottom: "1.5rem" }}>
        自分では難しいと感じたら、専門家にお任せください。相談は無料です。
      </p>

      {PROS.map((p) => (
        <div key={p.id} className="pro-card" onClick={() => setSelected(p)}>
          <div className="pro-top">
            <span className="pro-icon">{p.icon}</span>
            <div>
              <div className="pro-type">{p.type}</div>
              <div className="pro-price">報酬目安：{p.price}</div>
            </div>
            <span className="pro-arrow">›</span>
          </div>
          <p className="pro-desc">{p.desc}</p>
          <div className="pro-tags">
            {p.cases.map((c) => <span key={c} className="pro-tag">{c}</span>)}
          </div>
        </div>
      ))}

      <div className="notice">
        ⚠️ 成果報酬型の契約は行政書士法上認められていません。必ず着手金＋固定報酬でご依頼ください。
      </div>
    </div>
  );
}
